import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "lm_branch_filter";

export const useBranchFilter = () => {
  const [branches, setBranches] = useState([]);
  const [branchId, setBranch] = useState(() => sessionStorage.getItem(KEY) || "");
  useEffect(() => { api.get("/branches").then((r) => setBranches(r.data || [])).catch(() => setBranches([])); }, []);
  const setBranchId = (v) => {
    sessionStorage.setItem(KEY, v || "");
    setBranch(v || "");
  };
  return { branches, branchId, setBranchId, multiBranch: branches.filter((b) => b.units_total > 0).length > 1 };
};

export const BranchFilter = ({ branches, value, onChange, testid = "branch-filter" }) => {
  if (!(branches || []).length) return null;
  return (
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
      className="h-10 rounded-md border border-input bg-white px-3 text-sm">
      <option value="">Semua cabang</option>
      {branches.map((b) => (
        <option key={b.id} value={b.id}>{b.name} · {b.units_total} unit{b.status !== "Active" ? " (nonaktif)" : ""}</option>
      ))}
    </select>
  );
};
